// extracted by mini-css-extract-plugin
export var date = "VolunteerVacancyCard-module--date--04206";
export var distance = "VolunteerVacancyCard-module--distance--2d83b";
export var extrainfo = "VolunteerVacancyCard-module--extrainfo--b93c8";
export var leftcolumn = "VolunteerVacancyCard-module--leftcolumn--addcf";
export var linkwording = "VolunteerVacancyCard-module--linkwording--0a377";
export var nationallabel = "VolunteerVacancyCard-module--nationallabel--f2edc";
export var newlabel = "VolunteerVacancyCard-module--newlabel--dc195";
export var rightcolumn = "VolunteerVacancyCard-module--rightcolumn--05403";
export var vacancycardcontainer = "VolunteerVacancyCard-module--vacancycardcontainer--39275";
export var vacancycontainer = "VolunteerVacancyCard-module--vacancycontainer--ca039";
export var vacancylocation = "VolunteerVacancyCard-module--vacancylocation--8e519";
export var vacancyrole = "VolunteerVacancyCard-module--vacancyrole--cf791";